export function GetEnumKeyByEnumValue(
  myEnum: any,
  enumValue: number | string | null | undefined
): string | null {
  for (const key in myEnum) {
    if (myEnum[key] === enumValue) {
      return key;
    }
  }
  return null;
}
